import { render, staticRenderFns } from "./PackageTypesRegistryNewForm.vue?vue&type=template&id=47c09f06"
import script from "./PackageTypesRegistryNewForm.vue?vue&type=script&lang=js"
export * from "./PackageTypesRegistryNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports